/**
 * Created by dmitry on 04.09.2026
 */

SimpleMainSceneComponent.prototype.buildProgress = function () {
    return new SimpleAltProgressView();
};
